const $$splitComponentImporter = () => import('/app/src/routes/dashboard/client/sessions.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/client/sessions")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});